import React, { Component } from 'react'

import styles from '../../lib/global.css'
import Page from '../../components/page/page'
import bindAll from 'lodash.bindall'

import { getCourse } from '../../api/course'
import qs from 'qs'
import PageContentMargin from '../../components/page-content-margin/page-content-margin'
import BannerInfo from '../../components/banner-info/banner-info'
import MyLessonList from './my-lesson-list'
import { showLoading } from '../../components/loading/loading'
import { getClazz } from '../../api/clazz'


/**
 * 课程详情页
 */
class MyCoursePage extends Component {
  constructor(props) {
    super(props)
    bindAll(this, [
      'getCourse',
      'getClazz'
    ])
    this.query = qs.parse(this.props.location.search, { ignoreQueryPrefix: true })
    this.state = { course: { name: '', lessons: [] }, clazz: { code: '' } }
  }

  componentDidMount() {
    this.getCourse()
    this.getClazz()
  }

  getCourse() {
    getCourse({
      clazz_id: this.query.clazz_id,
      id: this.query.id,
    }, { quiet: !!this.state.course.id }).then(res => {
      this.assessMode = res.clazz_course.access
      this.setState({ course: res })
    })
  }

  getClazz() {
    getClazz({ id: this.query.clazz_id }, { quiet: !!this.state.clazz.id }).then(res => {
      this.setState({ ...this.state, clazz: res })
    })
  }

  render() {
    const { course, clazz } = this.state
    return (
      <Page isModal={true} title={course.name}>
        <PageContentMargin>
          {!!course.id &&
            <BannerInfo
              title={course.name}
              cover={course.cover}
              desc={course.clazz_course.clazz.name}
              buttons={
                <div style={{ width: '100%', marginTop: '1rem' }}>
                  <div className={styles.antRow} >
                    <label>{course.desc}</label>
                  </div>
                </div>
              }
            />
          }
          {course.lessons && course.lessons.length > 0 ? (
            <MyLessonList
              clazzId={parseInt(this.query.clazz_id)}
              courseId={course.id}
              lessons={course.lessons}
            />
          ) : (
            course.id && <div style={{ padding: '2rem' }}>{window.L('teach.course.noLesson')}</div>
          )}
        </PageContentMargin>
      </Page>
    )
  }
}
export default MyCoursePage
